export default ".stats-page {\n  padding-right: 20px;\n}";